import React from 'react';
import {
  Breadcrumb, Layout, List, Typography, Avatar,
} from 'antd';
import { MessageOutlined, UserOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const ChatsIndex = ({ chats = [] }) => (
  <div className="container">
    <Breadcrumb style={{ margin: '16px 0' }} items={[{ title: 'Чати' }]} />
    <Layout style={{ padding: '24px 0', background: '#fff', borderRadius: 8 }}>
      <Layout.Content style={{ padding: '0 48px' }}>
        <Typography.Title>Чати</Typography.Title>
        <List
          itemLayout="horizontal"
          dataSource={chats}
          locale={{ emptyText: 'Немає чатів' }}
          renderItem={(chat) => (
            <List.Item>
              <List.Item.Meta
                avatar={(
                  <Avatar
                    style={{ backgroundColor: '#1677ff' }}
                    icon={<UserOutlined />}
                  />
                )}
                title={(
                  <a href={`/chats/${chat.id}`}>
                    {chat.name}
                  </a>
                )}
                description={(
                  <span>
                    <UserOutlined style={{ marginRight: 4 }} />
                    {chat.userName}
                    {' | '}
                    <MessageOutlined style={{ marginRight: 4 }} />
                    {`${chat.messagesCount} повідомлень`}
                    {' | '}
                    {chat.updatedAt}
                    {chat.lastMessage && (
                      <>
                        <br />
                        <Typography.Text type="secondary">
                          {chat.lastMessage}
                        </Typography.Text>
                      </>
                    )}
                  </span>
                )}
              />
            </List.Item>
          )}
        />
      </Layout.Content>
    </Layout>
  </div>
);

ChatsIndex.propTypes = {
  chats: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      userName: PropTypes.string,
      lastMessage: PropTypes.string,
      messagesCount: PropTypes.number,
      updatedAt: PropTypes.string,
    }),
  ),
};

export default ChatsIndex;
